<template>
  <a-card :bordered="false" :bodyStyle="{ padding: '16px 36px', height: '100%' }" :style="{ height: '100%' }">
    <a-form-model :layout="'inline'">
      <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区选择">
        <a-tree-select
          :tree-data="zoneTreeData"
          v-model="query.zoneId"
          style="width: 250px"
          :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          placeholder="请选择片区"
          :treeDefaultExpandedKeys="treeDefaultExpandedKeys"
          show-search
          treeNodeFilterProp="title"
          allowClear
        ></a-tree-select>
      </a-form-model-item>
      <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="日期">
        <a-date-picker
          placeholder="请选择"
          :allowClear="false"
          v-model="query.statisticsDate"
          format="YYYY-MM-DD"
          valueFormat="YYYY-MM-DD"
          :open="open"
          @openChange="openChange"
          @panelChange="panelChange"
        />
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" style="margin-left: 20px" @click="queryList(false)" :disabled="refreshing">查询</a-button>
        <a-button
          style="margin-left: 8px"
          @click="
            query.zoneId = ''
            queryList(false)
          "
          >重置</a-button
        >
        <a-button type="primary" style="margin-left: 8px" @click="exportHandle()">导出</a-button>
        <a-button type="primary" style="margin-left: 8px" @click="openTimeSettingModal">时间段设置</a-button>
        <a-button type="primary" style="margin-left: 8px" @click="refreshTreeMenu" :disabled="refreshing">
          <span v-if="!refreshing">刷新数据</span>
          <span v-else>刷新中({{ countdown }}s)</span>
        </a-button>
      </a-form-model-item>
    </a-form-model>

    <a-spin :spinning="confirmLoading" style="margin-top: 15px" v-if="list.length > 0">
      <a-table
        :pagination="false"
        rowKey="id"
        bordered
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        :data-source="list"
        :columns="columns"
        :loading="dataListLoading"
      >
        <span slot="parent" slot-scope="text, record">{{ record.parentName }}</span>
        <span slot="statisticsDate" slot-scope="text, record">{{
          record.statistics ? record.statistics.statisticsDate : ''
        }}</span>
        <span slot="amountTo" slot-scope="text, record">{{
          record.statistics ? record.statistics.amountTo : ''
        }}</span>
        <span slot="referenceValues" slot-scope="text, record">{{
          record.statistics ? record.statistics.referenceValues : ''
        }}</span>
        <span
          slot="cz"
          slot-scope="text, record"
          :style="[
            record.statistics
              ? {
                  color:
                    record.statistics.amountTo - record.statistics.referenceValues >= 0
                      ? 'red'
                      : 'green',
                }
              : {},
          ]"
        >
          {{
            record.statistics
              ? (record.statistics.amountTo - record.statistics.referenceValues).toFixed(2)
              : ''
          }}
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="toworkbench(record)">详情</a>

          <a @click="addOrUpdateHandle(record)" style="margin-left: 15px">编辑</a>
        </span>
      </a-table>
    </a-spin>
    <a-empty v-else style="margin-top: 50px" />
    <a-modal
      title="编辑"
      style="top: 20px"
      :width="800"
      destroyOnClose
      v-model="addOrUpdateVisible"
      @ok="handleFormOk"
      @cancel="addOrUpdateVisible = false"
    >
      <a-form-model class="log-form" ref="addOrUpdateForm" :rules="rules">
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区名称" hasFeedback>
          {{ addOrUpdateForm.zoneName }}
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="参考值">
          <a-input-number placeholder="请输入" v-model="addOrUpdateForm.referenceValues" style="width: 150px" />
          <span style="margin-left: 10px">参考值更新时间：</span>{{ addOrUpdateForm.statisticsDate }}
          <span style="margin-left: 10px; color: #01b2ff; cursor: pointer" @click="updatelist">更新详情</span>
        </a-form-model-item>
        <a-form-model-item
          v-for="period in timePeriods"
          :key="period.id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="`${period.label}流量`"
        >
          <a-input-number
            placeholder="请输入"
            v-model="addOrUpdateForm[period.field]"
            :disabled="true"
            style="width: 150px"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal
      title="参考值更新记录"
      style="top: 20px"
      :width="800"
      destroyOnClose
      v-model="updatelistopen"
      :footer="null"
    >
      <a-table :dataSource="updatelistdata" :columns="columns2" :bordered="true" :pagination="false" />
    </a-modal>
    <!-- 时间段设置模态框 -->
    <a-modal
      title="时间段设置"
      style="top: 20px"
      :width="600"
      destroyOnClose
      v-model="timeSettingVisible"
      @ok="handleTimeSettingOk"
      @cancel="timeSettingVisible = false"
    >
      <div style="margin-bottom: 16px">
        <a-button type="dashed" style="width: 100%" @click="addTimePeriod">
          <a-icon type="plus" /> 添加时间段
        </a-button>
      </div>
      <a-table
        :dataSource="timePeriods"
        :columns="timePeriodColumns"
        :pagination="false"
        bordered
        size="small"
        rowKey="id"
      >
        <template slot="timeLabel" slot-scope="text, record, index">
          <a-input
            v-model="record.label"
            placeholder="请输入时间段名称（如：2点）"
            style="width: 100%"
            @blur="validateTimePeriod(record, index)"
          />
        </template>
        <template slot="timeValue" slot-scope="text, record, index">
          <a-input-number
            v-model="record.value"
            placeholder="请输入时间点（19-24或1-5）"
            :min="0"
            :max="24"
            style="width: 100%"
            @blur="validateTimePeriod(record, index)"
          />
        </template>
        <template slot="action" slot-scope="text, record, index">
          <a-button type="link" size="small" @click="removeTimePeriod(index)">删除</a-button>
        </template>
      </a-table>
      <!-- <div style="margin-top: 16px; color: #999; font-size: 12px">
        <a-icon type="info-circle" /> 提示：时间段名称用于显示，时间点用于数据统计（19-24点或1-5点），0点和24点都表示24点，字段名将自动转换为英文
      </div> -->
    </a-modal>
  </a-card>
</template>

<script>
import moment from 'moment'
import axios from 'axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import storage from 'store'

// 数字转英文函数（0-24，其中0点显示为24点）
function numberToEnglish(num) {
  // 0点使用 twentyFour（24点）
  if (num === 0 || num === 24) {
    return 'twentyFour'
  }
  
  const englishNumbers = [
    '', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine',
    'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen',
    'eighteen', 'nineteen', 'twenty', 'twentyOne', 'twentyTwo', 'twentyThree'
  ]
  return englishNumbers[num] || `num${num}`
}

// 验证时间点是否在 19-5 之间（跨天范围）
// 允许输入：19-24（包含24点，即0点） 和 1-5
function isValidTimeRange(value) {
  if (value === null || value === undefined) {
    return false
  }
  // 19-24 或 0-5 之间（0和24都表示24点）
  return (value >= 19 && value <= 24) || (value >= 0 && value <= 5)
}

// 默认时间段配置
const defaultTimePeriods = [
  { id: '1', label: '2点', value: 2, field: 'two' },
  { id: '2', label: '3点', value: 3, field: 'three' },
  { id: '3', label: '4点', value: 4, field: 'four' },
]

// 时间段设置表格列
const timePeriodColumns = [
  {
    title: '时间段名称',
    dataIndex: 'label',
    scopedSlots: { customRender: 'timeLabel' },
    width: '40%',
  },
  {
    title: '时间点',
    dataIndex: 'value',
    scopedSlots: { customRender: 'timeValue' },
    width: '40%',
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'action' },
    width: '20%',
  },
]

// 生成动态列配置
function generateColumns(timePeriods) {
  const baseColumns = [
    {
      title: '分区名称',
      dataIndex: 'zoneName',
      align: 'left',
      scopedSlots: { customRender: 'zoneAction' },
    },
    {
      title: '日期',
      dataIndex: 'statisticsDate',
      scopedSlots: { customRender: 'statisticsDate' },
    },
  ]

  // 动态添加时间段列，使用 customRender 函数
  const periodColumns = timePeriods.map((period) => {
    const fieldName = period.field // 闭包捕获字段名
    return {
      title: period.label,
      dataIndex: fieldName,
      customRender: (text, record) => {
        if (record.statistics && record.statistics[fieldName] !== undefined) {
          return record.statistics[fieldName]
        }
        return ''
      },
    }
  })

  const endColumns = [
    {
      title: '合计',
      scopedSlots: { customRender: 'amountTo' },
    },
    {
      title: '参考值',
      scopedSlots: { customRender: 'referenceValues' },
    },
    {
      title: '差值',
      scopedSlots: { customRender: 'cz' },
    },
    {
      title: '操作',
      width: '150px',
      dataIndex: 'action',
      scopedSlots: { customRender: 'action' },
    },
  ]

  return [...baseColumns, ...periodColumns, ...endColumns]
}
const list = []
const columns2 = [
  {
    title: '序号',
    dataIndex: '',
    key: 'rowIndex',
    customRender: function (t, r, index) {
      return parseInt(index) + 1
    },
  },

  {
    title: '参考值',
    dataIndex: 'referenceValues',
  },
  {
    title: '更新时间',
    dataIndex: 'updateTime',
  },
]
function GetDateStr(AddDayCount) {
  var dd = new Date()
  dd.setDate(dd.getDate() + AddDayCount) // 获取AddDayCount天后的日期
  var y = dd.getFullYear()
  var m = dd.getMonth() + 1 // 获取当前月份的日期
  var d = dd.getDate()
  if (m < 10) m = '0' + m
  if (d < 10) d = '0' + d
  return y + '-' + m + '-' + d + ' 00:00:00'
}
export default {
  name: 'nighttimeMinStatistics',
  components: {},
  data() {
    // 从本地存储加载时间段配置，如果没有则使用默认配置
    let savedTimePeriods = null
    try {
      const saved = localStorage.getItem('nighttimeMinStatistics_timePeriods')
      if (saved) {
        savedTimePeriods = JSON.parse(saved)
      }
    } catch (e) {
      console.error('加载时间段配置失败:', e)
    }
    const initialTimePeriods = savedTimePeriods && savedTimePeriods.length > 0 ? savedTimePeriods : defaultTimePeriods
    
    // 确保所有时间段的字段名都是根据时间点生成的英文
    initialTimePeriods.forEach((period) => {
      if (period.value !== null && period.value !== undefined) {
        period.field = numberToEnglish(period.value)
      }
    })

    return {
      updatelistopen: false,
      rules: {
        referenceValues: [
          { required: true, message: '', trigger: 'change' },
          { pattern: /^[0-9]+\.?[0-9]*$/, message: '请输入正确的值', trigger: 'change' },
        ],
      },
      updatelistdata: [],
      exportDataUrl: 'pipe-network/traffic/statistics/export',
      addOrUpdateVisible: false,
      zoneId: '',
      treeDefaultExpandedKeys: [], //默认展开的树节点
      query: {
        statisticsDate: GetDateStr(0),
        zoneId: '',
      },
      open: false,
      record: {},
      fivedisabled: false,
      threedisabled: false,
      fourdisabled: false,
      confirmLoading: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      dataListLoading: false,

      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
      },
      list: [],
      zoneTreeData: [], // 片区选项
      columns: generateColumns(initialTimePeriods),
      columns2,
      timePeriodColumns,

      // 时间段相关
      timeSettingVisible: false,
      timePeriods: JSON.parse(JSON.stringify(initialTimePeriods)), // 时间段列表
      periodDisabledMap: {}, // 时间段禁用状态映射

      addOrUpdateForm: {},
      exportLoading: false,
      refreshing: false,
      countdown: 10,
      countdownTimer: null,
    }
  },

  computed: {},
  methods: {
    moment,
    // 从后端加载时间段配置
    async loadTimePeriodsFromStorage() {
      try {
        const res = await this.$http.get('pipe-network/traffic/statistics/custom/hour/config')
        if (res.code === 0 && res.data) {
          // 后端返回单个对象，包含 hourPointList 数组
          const config = res.data
          if (config.hourPointList && config.hourPointList.length > 0) {
            // 将 hourPointList 数组转换为前端需要的时间段配置数组
            return config.hourPointList.map((hour, index) => ({
              id: `${config.id}_${index}`,  // 使用配置ID+索引作为唯一标识
              label: `${hour}点`,
              value: hour,
              field: numberToEnglish(hour)
            }))
          }
        }
      } catch (e) {
        console.error('加载时间段配置失败:', e)
      }
      // 如果接口失败，尝试从 localStorage 加载（兼容旧数据）
      try {
        const saved = localStorage.getItem('nighttimeMinStatistics_timePeriods')
        if (saved) {
          return JSON.parse(saved)
        }
      } catch (e) {
        console.error('从本地存储加载失败:', e)
      }
      return null
    },
    // 保存时间段配置到后端
    async saveTimePeriodsToStorage() {
      try {
        // 将前端格式转换为后端需要的格式
        const hourPoints = this.timePeriods.map(period => period.value)
        const params = { hourPoints }
        
        const res = await this.$http.post('pipe-network/traffic/statistics/custom/hour/config', params)
        if (res.code === 0) {
          // 同时保存到 localStorage 作为备份
          localStorage.setItem('nighttimeMinStatistics_timePeriods', JSON.stringify(this.timePeriods))
          return true
        } else {
          this.$message.error(res.message || '保存时间段配置失败')
          return false
        }
      } catch (e) {
        console.error('保存时间段配置失败:', e)
        this.$message.error('保存时间段配置失败')
        return false
      }
    },
    // 打开时间段设置模态框
    async openTimeSettingModal() {
      // 从后端重新加载，确保显示最新配置
      const saved = await this.loadTimePeriodsFromStorage()
      if (saved && saved.length > 0) {
        this.timePeriods = JSON.parse(JSON.stringify(saved))
        // 确保字段名正确
        this.timePeriods.forEach((period) => {
          if (period.value !== null && period.value !== undefined) {
            period.field = numberToEnglish(period.value)
          }
        })
      } else {
        this.timePeriods = JSON.parse(JSON.stringify(defaultTimePeriods))
        // 确保字段名正确
        this.timePeriods.forEach((period) => {
          if (period.value !== null && period.value !== undefined) {
            period.field = numberToEnglish(period.value)
          }
        })
      }
      this.timeSettingVisible = true
    },
    // 添加时间段
    addTimePeriod() {
      const newId = Date.now().toString()
      const newPeriod = {
        id: newId,
        label: '',
        value: null,
        field: '', // 字段名将在保存时根据时间点自动生成
      }
      this.timePeriods.push(newPeriod)
    },
    // 删除时间段
    removeTimePeriod(index) {
      if (this.timePeriods.length <= 1) {
        this.$message.warning('至少需要保留一个时间段')
        return
      }
      this.timePeriods.splice(index, 1)
    },
    // 验证时间段
    validateTimePeriod(record, index) {
      if (!record.label || record.label.trim() === '') {
        this.$message.warning(`第${index + 1}行的时间段名称不能为空`)
        return false
      }
      if (record.value === null || record.value === undefined) {
        this.$message.warning(`第${index + 1}行的时间点不能为空`)
        return false
      }
      // 验证时间点是否在 19-5 之间（跨天范围）
      if (!isValidTimeRange(record.value)) {
        this.$message.warning(`第${index + 1}行的时间点必须在19-24点或1-5点之间`)
        return false
      }
      return true
    },
    // 时间段设置确认
    async handleTimeSettingOk() {
      // 验证所有时间段
      let isValid = true
      for (let i = 0; i < this.timePeriods.length; i++) {
        if (!this.validateTimePeriod(this.timePeriods[i], i)) {
          isValid = false
          break
        }
      }

      if (!isValid) {
        return
      }

      // 检查是否有重复的时间点
      const valueSet = new Set()
      for (const period of this.timePeriods) {
        if (valueSet.has(period.value)) {
          this.$message.warning(`时间点 ${period.value} 重复，请修改`)
          return
        }
        valueSet.add(period.value)
      }

      // 根据时间点生成英文字段名（确保字段名唯一）
      const fieldSet = new Set()
      this.timePeriods.forEach((period, index) => {
        // 将时间点转换为英文作为字段名
        const englishField = numberToEnglish(period.value)
        period.field = englishField
        
        // 如果字段名重复，添加索引后缀
        if (fieldSet.has(period.field)) {
          period.field = `${englishField}_${index}`
        }
        fieldSet.add(period.field)
      })

      // 保存配置到后端
      const saved = await this.saveTimePeriodsToStorage()
      if (!saved) {
        return // 保存失败，不关闭弹窗
      }

      // 更新表格列
      this.columns = generateColumns(this.timePeriods)

      // 调试信息
      console.log('时间段配置:', this.timePeriods)
      console.log('表格列配置:', this.columns)

      this.timeSettingVisible = false
      this.$message.success('时间段设置保存成功')
      
      // 重新加载数据
      this.queryList(false)
    },
    // 获取时间段禁用状态
    getPeriodDisabled(field) {
      return this.periodDisabledMap[field] || false
    },
    exportHandle() {
      this.exportLoading = true
      const token = storage.get(ACCESS_TOKEN)
      const params = {
        responseType: 'arraybuffer',
        params: {
          statisticsDate: this.query.statisticsDate,
          zoneId: this.query.zoneId,
        },
        headers: {
          Authorization: token,
        },
      }
      const url = `${process.env.VUE_APP_API_BASE_URL}${this.exportDataUrl}`
      axios
        .get(url, params)
        .then((res) => {
          const blob = new Blob([res.data], { type: 'application/octet-stream;charset=utf-8' })
          const fileName = this.exportFileName || '导出数据.xls'
          const eLink = document.createElement('a')
          eLink.download = fileName
          eLink.style.display = 'none'
          eLink.href = URL.createObjectURL(blob)
          document.body.appendChild(eLink)
          eLink.click()
          URL.revokeObjectURL(eLink.href)
          document.body.removeChild(eLink)
          this.$message.success('导出完成')
          this.exportLoading = false
        })
        .catch(() => {
          this.exportLoading = false
        })
    },
    addOrUpdateHandle(row) {
      // 重置禁用状态映射
      this.periodDisabledMap = {}

      if (row.statistics) {
        this.addOrUpdateForm = JSON.parse(JSON.stringify(row.statistics))

        // 根据时间段配置设置禁用状态
        this.timePeriods.forEach((period) => {
          const value = this.addOrUpdateForm[period.field]
          // 如果值不为0且不为空，则禁用编辑
          if (value != null && value != 0) {
            this.periodDisabledMap[period.field] = true
          } else {
            this.periodDisabledMap[period.field] = false
          }
        })
      } else {
        // 初始化表单数据
        const formData = {
          statisticsDate: this.query.statisticsDate,
          zoneId: row.zoneId,
          zoneName: row.zoneName,
          referenceValues: null,
        }
        // 为每个时间段初始化字段
        this.timePeriods.forEach((period) => {
          formData[period.field] = null
          this.periodDisabledMap[period.field] = false
        })
        this.addOrUpdateForm = formData
      }

      this.addOrUpdateVisible = true
    },

    toworkbench(row) {
      const routeUrl = this.$router.resolve({
        path: '/partition/workbench',
        query: {
          type: 'night_flow',
          zoneId: row.zoneId,
          startTime: this.query.statisticsDate,
        },
      })
      window.open(routeUrl.href, '_blank')
    },
    handleFormOk(e) {
      e.preventDefault()
      if (!this.addOrUpdateForm.referenceValues) {
        this.$message.warning('参考值不能为空')

        return
      }
      this.addOrUpdateForm.id = ''
      this.$http['post']('pipe-network/traffic/statistics/save', this.addOrUpdateForm)
        .then((res) => {
          if (res.code === 0) {
            this.addOrUpdateVisible = false
            this.queryList()
            this.$refs.addOrUpdateForm.resetFields()
            this.$message.success(res.message)
          }
        })
        .catch(() => {})
    },
    updatelist() {
      this.$http['get']('pipe-network/traffic/statistics/reference/value?zoneId=' + this.addOrUpdateForm.zoneId)
        .then((res) => {
          if (res.code === 0) {
            this.updatelistdata = res.data
            this.updatelistopen = true
          }
        })
        .catch(() => {})
    },
    chuli(n) {
      if (n != null && n.length !== 0) {
        n.map((item) => {
          item.children = this.chuli(item.children)

          if (item.level == 1) {
            this.treeDefaultExpandedKeys.push(item.id)
          }
        })
        return n
      } else {
        return n
      }
    },
    //更新数据
    queryList(iscreadted) {
      // 触发表单验证
      this.confirmLoading = true
      let params = this.query
      if (params.statisticsDate) {
        params.statisticsDate = moment(params.statisticsDate).format('YYYY-MM-DD')
      }

      this.$http
        .get('pipe-network/traffic/statistics/custom/hour', { params })
        .then((res) => {
          if (res.code == 0) {
            this.list = res.data
            // 调试信息
            if (this.list.length > 0 && this.list[0].statistics) {
              console.log('第一条数据的areaTrafficStatistics:', this.list[0].statistics)
              console.log('当前时间段配置:', this.timePeriods)
              console.log('当前表格列配置:', this.columns)
            }
            if (iscreadted) {
              this.zoneTreeData = res.data
              this.chuli(this.zoneTreeData)
            }
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    panelChange(value) {
      this.query.statisticsDate = value
      this.open = false
    },
    openChange(status) {
      if (status) {
        this.open = true
      } else {
        this.open = false
        this.queryList(false)
      }
    },
    async refreshTreeMenu() {
      this.refreshing = true
      this.countdown = 10
      try {
        await this.$http.get('pipe-network/traffic/statistics/update/tree/menu')
        this.startCountdown()
      } catch (e) {
        this.$message.error('刷新失败')
        this.refreshing = false
      }
    },
    startCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
      }
      this.countdownTimer = setInterval(() => {
        if (this.countdown > 1) {
          this.countdown--
        } else {
          clearInterval(this.countdownTimer)
          this.refreshing = false
          this.queryList(false)
        }
      }, 1000)
    },
  },
  async created() {
    // 先加载时间段配置，再查询列表数据
    const saved = await this.loadTimePeriodsFromStorage()
    if (saved && saved.length > 0) {
      this.timePeriods = saved
      // 确保字段名正确
      this.timePeriods.forEach((period) => {
        if (period.value !== null && period.value !== undefined) {
          period.field = numberToEnglish(period.value)
        }
      })
      // 更新表格列配置
      this.columns = generateColumns(this.timePeriods)
    }
    
    // 查询数据
    this.queryList(true)
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer)
    }
  },
}
</script>

<style lang="less" scoped>
.tableCol {
  height: 40px;
}

/* 自定义table样式 */
table.gridtable {
  margin-top: 20px;
  width: 100%;
  font-size: 16px;
  /* color:#FFF; */
  border-width: 1px;
  text-align: center;
  border-color: #ffffff;
  border-collapse: collapse;
}

table.gridtable th {
  /**表头样式 */
  border-width: 1px;
  color: #fff;
  padding: 8px;
  border-style: solid;
  border-color: #888888;
  background-color: #f1f2f6;
}

table.gridtable td {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #888888;
  background-color: #f1f2f6;
}

table.gridtable td.tableName {
  /**表格class为tableName的样式 */
  color: black;
  background-color: #f1f2f6;
  text-align: center;
  width: 200px;
  border: 1px #888888 solid;
}

table.gridtable td.tableValue {
  /**表格class为tableValue的样式 */
  background-color: #f1f2f6;
  text-align: right;
}

table.gridtable td.tableTitle {
  /**表格class为tableTitle的样式 */
  /* background-color: #F8F8F8; */
  text-align: left;
  font-weight: 400;
}

table.gridtable td.tableValue:hover {
  /**鼠标指项某一格时的样式 */
  background-color: #f1f2f6;
}

.blueFont {
  color: blue;
}
</style>
